var React = require('react');

function BuildingTenancy (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 12H7V10H3V12H0V0H10V12ZM8 6H6V8H8V6ZM2 6H4V8H2V6ZM8 2H6V4H8V2ZM2 2H4V4H2V2Z","fill":"white"}));
}

BuildingTenancy.defaultProps = {"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none"};

module.exports = BuildingTenancy;

BuildingTenancy.default = BuildingTenancy;
